import React, { useState, useEffect } from "react";
import axios from "axios";
import Profile from "./Profile";
// import Sidebar from "../Sidebar";

function ProfilePage({ name }) {
  const [total, setTotal] = useState(0);
  const [easy, setEasy] = useState(0);
  const [medium, setMedium] = useState(0);
  const [hard, setHard] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getStats = async () => {
      try {
        const res = await axios.get(`https://leetcode-stats-api.herokuapp.com/${name}`);
        setTotal(res.data.totalSolved);
        setEasy(res.data.easySolved);
        setMedium(res.data.mediumSolved);
        setHard(res.data.hardSolved);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching stats:", err);
      } finally {
        setLoading(false);
      }
    };
    getStats();
  }, [name]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="flex min-h-screen bg-[#222831]">
      

      {/* Main content takes rest of space */}
      <main className="flex-1 p-6">
        <div className="flex flex-col md:flex-row gap-8 w-full max-w-6xl mx-auto items-stretch">
          {/* Profile Card */}
          <div className="w-full md:w-80 rounded-lg bg-gradient-to-br from-[#FDE68A] via-[#F59E0B] to-[#B45309] hover:bg-gray-200 shadow-md p-8 flex flex-col justify-between">
            <div>
              <h1 className="text-left font-bold text-lg text-gray-800">AIR</h1><br />
              <img
                src={`https://ui-avatars.com/api/?name=${name}`}
                alt="Profile"
                className="rounded-full h-28 w-28 mx-auto"
              /><br />
              <p className="text-sm text-gray-600 font-bold text-center">DataStructures-rank: 2</p>
              <p className="text-sm text-gray-600 font-bold text-center">CP-rank: 1</p>
            </div>
          </div>

          {/* Report Analysis Card */}
          <div className="flex-1 bg-[#f3f4f6] rounded-lg shadow-md p-8 flex flex-col justify-between">
            <h1 className="text-gray-700 text-xl font-bold mb-4 text-center">
              Your Report Analysis Of Leetcode
            </h1>
            <div className="flex justify-center items-center flex-grow">
              <Profile total={total} easy={easy} medium={medium} hard={hard} />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ProfilePage;
